
const systemInfo = {
  namespaced: true,
  state: {
    systemInfo: {
      name: '',
      subTitle: '',
      hasPortal: true,
      portalPath: '',
      copyRight: '',
      logoPath: '',
      headerBgPath: '',
      theme: '',
      menuLayout: 'LEFT',
      isPc: true,
      authModel: 'server',
      systemCode: 'agility'
    }
  },
  getters: {
    systemInfo: state => state.systemInfo,
    theme: state => state.systemInfo?.theme,
    isPc: state => state.systemInfo?.isPc,
    menuLayout: state => state.systemInfo?.menuLayout,
    systemCode: state => state.systemInfo?.systemCode || 'agility',
    authModel: state => state.systemInfo?.authModel || 'server',
  },
  mutations: {
    SET_SYSTEMINFO (state, payload) {
      state.systemInfo = payload
    },
    SET_SYSTEMINFO_PARAMTER (state, payload) {
      // 直接异常抛掉
      if (payload.key == undefined || payload.key == null) throw Error("please check data key!")
      state.systemInfo[payload.key] = payload.value
    },
  },
  actions: {
    // 登录操作
    async updateSystemInfo (context, data) {
      // 触发mutation，存储data
      context.commit("SET_SYSTEMINFO", data)
    },
    async updateSystemInfoParams (context, data) {
      // 触发mutation，存储data
      if (data instanceof Array) {
        data.forEach(item => {
          context.commit("SET_SYSTEMINFO_PARAMTER", item)
        })
      } else {
        context.commit("SET_SYSTEMINFO_PARAMTER", data)
      }
    },
  }
}

export default systemInfo